import {defaultSettings} from "./defaultSettings";
import {envConfigMap} from "./env";
import {request, logToKazmon, baseLogData} from "../lib/api";
import {createInstance} from '@optimizely/optimizely-sdk';
import {getQueryParam} from "../lib/getQueryParam";
import * as api from "../lib/api";
import _ from "lodash";

let optimizelyInstance = null;
let settings = null;
let environment = null;
let envConfig = null;

const format = (message, auxData) => {
  if (auxData &&
    (
      _.isPlainObject(auxData) ||
      _.isString(auxData)
    )
  ) {
    return { message, details: _.identity(auxData) }
  }
  return null
}

const kazmonLog = (message, auxData) => {
  // ensure data logged is an object
  const data = format(message, auxData)

  const baseLog = api.baseLogData()
  logToKazmon(JSON.stringify({
    data,
    ...baseLog,
  }))
}

export const postOptimizelyReady = (result, resolve, optimizely, decodedQueryParams) => {
  if (!result.success) {
    resolve(defaultSettings);
    return;
  }
  optimizelyInstance = optimizely;
  const powerformAnonymousUser = 'powerform_anonymous_user';

  const accountId = getQueryParam(decodedQueryParams, "accountId") || getQueryParam(decodedQueryParams, "acct")
  const env = getQueryParam(decodedQueryParams, "env").toLowerCase()
  const powerformId = window.location.pathname.slice(1)
  const optimizelyUserContext = optimizely.createUserContext(powerformAnonymousUser, {
    accountId,
    env,
    powerformId
  })
  const defaultFlagKeys = Object.keys(defaultSettings);
  const optimizelyValues = {};
  defaultFlagKeys.forEach(flagKey => {
    const decision = optimizelyUserContext.decide(flagKey);
    optimizelyValues[flagKey] = decision.enabled;
  })
  kazmonLog("Pure Optimizely Flags", optimizelyValues);
  settings = {
    ...defaultSettings,
    ...optimizelyValues
  };
  kazmonLog("Evaluated Optimizely Flags", optimizelyValues);
  resolve(settings);
}

export const initializeOptimizely = (config, resolve, decodedQueryParams) => {
  try {
    // Use optimizely data directly from the config endpoint response
    if (!config.optimizelyData || !config.optimizelyConfig) {
      console.error("Missing Optimizely data in config response");
      resolve(defaultSettings);
      return;
    }

    const optimizely = createInstance({
      sdkKey: config.optimizelyConfig.sdkKey,
      datafile: config.optimizelyData
    });

    if (!optimizely) {
      resolve(defaultSettings);
      return;
    }

    optimizely.onReady()
      .then(result => postOptimizelyReady(result, resolve, optimizely, decodedQueryParams))
      .catch(error => {
        console.error("Error creating optimizely instance", error);
        resolve(defaultSettings);
      });
  } catch (error) {
    console.error("Error initializing Optimizely", error);
    resolve(defaultSettings);
  }
}

export const getSettings = (queryParams) => {
  return new Promise(resolve => {
    const decodedQueryParams = queryParams.replace(/amp;/gi, "").replace(/amp%3B/gi, "")
    if (settings) {
      resolve(settings);
      return;
    }

    // Make a single request to the config endpoint which now also includes Optimizely data
    request("/config", {method: "GET"}, decodedQueryParams, queryParams)
      .then((configResponse) => {
        environment = configResponse.data.env;
        envConfig = envConfigMap[environment];
        kazmonLog(`Running in environment : ${environment}`, { env: environment });

        // Initialize Optimizely directly from the config response
        initializeOptimizely(configResponse.data, resolve, decodedQueryParams);
      }).catch((error) => {
        console.error("Error fetching settings", error);
        resolve(defaultSettings);
      });
  });
}
